import { defineActions } from './defineActions'

const area = 'Appointment notifications'

/**
 * IME appointment notifications (manual sends and resends of the appointment emails, DocuSign
 * consent, interpreter emails). Action names start with Ime.Notification. The notify ticks
 * themselves are saved by the footer Save (Ime.Appointment.Save, in ime-page.ts).
 */
export const appointmentNotificationActions = defineActions({
  // Sending Appointment Inquiry > Resend
  'Ime.Notification.AppointmentInquiry.ResendToStaffPic': {
    label: 'Resend appointment inquiry to Staff PIC',
    area,
  },
  'Ime.Notification.AppointmentInquiry.ResendToBookingCm': {
    label: 'Resend appointment inquiry to Booking CM',
    area,
  },
  'Ime.Notification.AppointmentInquiry.ResendToSpecialist': {
    label: 'Resend appointment inquiry to Specialist',
    area,
  },
  // Send Reminder for Requested Appointment > Resend
  'Ime.Notification.AppointmentRequestReminder.ResendToStaffPic': {
    label: 'Resend requested appointment reminder to Staff PIC',
    area,
  },
  // Resend Appointment Confirmation
  'Ime.Notification.AppointmentConfirmation.ResendToStaffPic': {
    label: 'Resend appointment confirmation to Staff PIC',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToInterpreter': {
    label: 'Resend appointment confirmation to Interpreter',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToClaimant': {
    label: 'Resend appointment confirmation to Claimant',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToBookingCm': {
    label: 'Resend appointment confirmation to Booking CM',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToBookingSolicitor': {
    label: 'Resend appointment confirmation to Booking Solicitor',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToSpecialist': {
    label: 'Resend appointment confirmation to Specialist',
    area,
  },
  'Ime.Notification.AppointmentConfirmation.ResendToSurrogateClinic': {
    label: 'Resend appointment confirmation to Surrogate Clinic Centre',
    area,
  },
  // Send Appointment Reminders
  'Ime.Notification.AppointmentReminder.SendToBookingCm': {
    label: 'Send appointment reminder to Booking CM',
    area,
  },
  'Ime.Notification.AppointmentReminder.SendToClaimant': {
    label: 'Send appointment reminder to Claimant',
    area,
  },
  'Ime.Notification.AppointmentReminder.SendToSpecialist': {
    label: 'Send appointment reminder to Specialist',
    area,
  },
  // Appointment Reschedule Update > Resend Reschedule Update
  'Ime.Notification.AppointmentReschedule.ResendToStaffPic': {
    label: 'Resend reschedule update to Staff PIC',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToInterpreter': {
    label: 'Resend reschedule update to Interpreter',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToClaimant': {
    label: 'Resend reschedule update to Claimant',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToBookingCm': {
    label: 'Resend reschedule update to Booking CM',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToBookingSolicitor': {
    label: 'Resend reschedule update to Booking Solicitor',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToSpecialist': {
    label: 'Resend reschedule update to Specialist',
    area,
  },
  'Ime.Notification.AppointmentReschedule.ResendToSurrogateClinic': {
    label: 'Resend reschedule update to Surrogate Clinic Centre',
    area,
  },
  // Consent form (DocuSign)
  'Ime.Notification.ConsentForm.GenerateDocuSignLink': {
    label: 'Generate new DocuSign consent link',
    area,
  },
  'Ime.Notification.ConsentForm.SyncDocuSignStatus': {
    label: 'Sync DocuSign consent status',
    area,
  },
  // Interpreter Information
  'Ime.Notification.Interpreter.ResendRequestToStaffPic': {
    label: 'Resend interpreter request to Staff PIC',
    area,
  },
  'Ime.Notification.Interpreter.ResendRequestToProvider': {
    label: 'Resend interpreter request to Interpreter Provider',
    area,
  },
  'Ime.Notification.Interpreter.ResendCancellationNotice': {
    label: 'Resend cancellation notice to Interpreter',
    area,
  },
  'Ime.Notification.Interpreter.ResendConfirmationToBookingCm': {
    label: 'Resend interpreter confirmation to Booking CM',
    area,
  },
  'Ime.Notification.Interpreter.ResendConfirmationToSpecialist': {
    label: 'Resend interpreter confirmation to Specialist',
    area,
  },
})
